export default {
  apiKey: "AIzaSyBOgKUn2-_W8NM52QTZQpka00k9yKR4wtQ",
  authDomain: "ngpanel.firebaseapp.com",
  projectId: "ngpanel",
  storageBucket: "ngpanel.appspot.com",
  messagingSenderId: "541683632867",
  appId: "1:541683632867:web:5461b235fabf9275cd53d6"
}
